<template>
  <div class="dict">
    <div class="addCooperation">
      <!-- tab页 -->
      <el-tabs class="addCooperationTabs" type="border-card">
        <!-- 仓储信息 -->
        <el-tab-pane :label="this.$t('warehouseContract.form.warehouseInfo')">
          <el-form :model="formData" :rules="rules" ref="formData" label-width="90px">
            <el-collapse v-model="activeNames" class="collapse-main-content">
              <el-collapse-item v-if="contractStatus == 'ZT03'" name="3">
                <template slot="title">
                  <div class="collapse-title-pre"
                    ><span></span>{{ this.$t('warehouseContract.form.editTitle') }}</div
                  >
                </template>
                <div class="collapse-content">
                  <el-form-item prop="editReason" :label="$t('warehouseContract.form.editTitle')">
                    <el-input
                      v-model="formData.editReason"
                      :placeholder="$t('warehouseContract.form.editResonPlaceholder')"
                      type="textarea"
                      clearable
                      maxlength="256"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-collapse-item>
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="collapse-title-pre"
                    ><span></span>{{ this.$t('warehouseContract.form.basicInfo') }}</div
                  >
                </template>
                <div class="collapse-content">
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractEnterpriseNo"
                        :label="this.$t('warehouseContract.form.contractEnterpriseNo')"
                      >
                        <search-table
                          v-model="formData.contractEnterpriseNo"
                          searchType="partner"
                          :isMultiple="true"
                          :disabled="canNotEdit"
                          :checkRowKeys="[formData.contractEnterpriseNo] || []"
                          :currentValue="formData.contractEnterpriseName"
                          propName="storageName"
                          propCode="storageCode"
                          :placeholder="
                            $t('warehouseContract.form.contractEnterpriseNoPlaceholder')
                          "
                          :extraData="{
                            partnerTypes: 'HZHB07,HZHB02,HZHB03',
                          }"
                          @input="setWarehouseIn"
                        ></search-table>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="registeredAssets"
                        :label="this.$t('warehouseContract.form.registeredAssets')"
                      >
                        <input-number-ad
                          style="width: 100%"
                          v-model="formData.registeredAssets"
                          :disabled="canNotEdit"
                          :controls="false"
                          max="99999999999.999999"
                          :placeholder="
                            this.$t('warehouseContract.form.registeredAssetsPlaceholder')
                          "
                          :clearable="true"
                        >
                        </input-number-ad>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contactPersonNo"
                        :label="this.$t('warehouseContract.form.contactPersonNo')"
                      >
                        <el-input
                          v-model="formData.contactPersonNo"
                          :disabled="canNotEdit"
                          :placeholder="
                            this.$t('warehouseContract.form.contactPersonNoPlaceholder')
                          "
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contactPhone"
                        :label="this.$t('warehouseContract.form.contactPhone')"
                      >
                        <el-input
                          v-model="formData.contactPhone"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.contactPhonePlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="signDate"
                        :label="this.$t('warehouseContract.form.signDate')"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="formData.signDate"
                          :disabled="canNotEdit"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :placeholder="this.$t('warehouseContract.form.signDatePlaceholder')"
                          clearable
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="valideDateTo"
                        :label="this.$t('warehouseContract.form.valideDateTo')"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="formData.valideDateTo"
                          :disabled="canNotEdit"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :placeholder="this.$t('warehouseContract.form.valideDateToPlaceholder')"
                          clearable
                        >
                        </el-date-picker>
                        <!-- <el-input v-model="formData.valideDateTo"  :disabled="canNotEdit"
                                                :placeholder='this.$t("warehouseContract.form.valideDateToPlaceholder")'>
                                            </el-input> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="inboundMethod"
                        :label="this.$t('warehouseContract.form.inboundMethod')"
                      >
                        <el-select
                          style="width: 100%"
                          v-model="formData.inboundMethod"
                          filterable
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.inboundMethodPlaceholder')"
                          @change="changeInboundMethod"
                          clearable
                        >
                          <el-option
                            v-for="item in inboundMethodList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="formData.inboundMethod === 'RK01'">
                      <el-form-item
                        prop="stationName"
                        :label="this.$t('warehouseContract.form.stationName')"
                      >
                        <el-input
                          v-model="formData.stationName"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.stationNamePlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="formData.inboundMethod !== 'RK01'">
                      <el-form-item
                        prop="station"
                        :label="this.$t('warehouseContract.form.stationName')"
                        :rules="[]"
                      >
                        <el-input
                          v-model="formData.stationName"
                          :disabled="true"
                          :placeholder="this.$t('warehouseContract.form.stationNamePlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="goodsControlAmount"
                        :label="this.$t('warehouseContract.form.goodsControlAmount')"
                      >
                        <input-number-ad
                          style="width: 100%"
                          v-model="formData.goodsControlAmount"
                          :disabled="canNotEdit"
                          :controls="false"
                          max="99999999999.999999"
                          :placeholder="
                            this.$t('warehouseContract.form.goodsControlAmountPlaceholder')
                          "
                          :clearable="true"
                        >
                        </input-number-ad>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractVenue"
                        :label="this.$t('warehouseContract.form.contractVenue')"
                      >
                        <el-input
                          v-model="formData.contractVenue"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.contractVenuePlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="chargeStandard"
                        :label="this.$t('warehouseContract.form.chargeStandard')"
                      >
                        <el-input
                          v-model="formData.chargeStandard"
                          :disabled="canNotEdit"
                          :placeholder="this.$t('warehouseContract.form.chargeStandardPlaceholder')"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <div class="gird">
                    <vxe-toolbar size="mini">
                      <template v-slot:buttons>
                        <vxe-button
                          size="medium"
                          type="primary"
                          class="vxe-btn-primary"
                          icon="el-icon-plus"
                          @click="insertRow('xGrid')"
                        >
                          {{ $t('credit.btnList.add') }}
                        </vxe-button>
                        <vxe-button
                          size="medium"
                          type="primary"
                          class="vxe-btn-delete"
                          icon="el-icon-delete"
                          @click="removeSelected('xGrid')"
                        >
                          {{ $t('credit.btnList.del') }}
                        </vxe-button>
                      </template>
                    </vxe-toolbar>
                    <vxe-grid
                      border
                      show-overflow
                      resizable
                      ref="xGrid"
                      class="vxe-table-element"
                      size="mini"
                      align="left"
                      :auto-resize="true"
                      :data="warehouseData"
                      :edit-rules="warehouseEditRules"
                      @cell-click="warehouseRowClick"
                      :edit-config="{ trigger: 'click', mode: 'row' }"
                    >
                      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                      <vxe-table-column
                        type="index"
                        width="60"
                        :title="$t('table.index')"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="storageNo"
                        :title="$t('warehouseContract.form.storageNo')"
                        :edit-render="{ name: 'searchModal' }"
                      >
                        <template v-slot:edit="{ row }">
                          <SearchModal
                            ref="searchModal"
                            propName="storageCode"
                            propCode="storageCode"
                            className="customer-search"
                            model="storageNo"
                            :placeholder="$t('warehouseContract.form.storagePlaceholder')"
                            :API="warehouse.API"
                            :query="warehouse.query"
                            :page="warehouse.page"
                            :searchColumns="warehouse.searchColumns"
                            :columnList="warehouse.columnList"
                            :isMultiple="true"
                            :currentValue="row.storageNo"
                            @setSearchModal="(name, val) => setWarehouse(name, val, row)"
                          ></SearchModal>
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="storageName"
                        :title="$t('warehouseContract.form.storageName')"
                        :edit-render="{ name: 'searchModal' }"
                      >
                        <template v-slot:edit="{ row }">
                          <SearchModal
                            ref="searchModal"
                            propName="storageName"
                            propCode="storageCode"
                            model="storageName"
                            className="customer-search"
                            :placeholder="$t('warehouseContract.form.storagePlaceholder')"
                            :API="warehouse.API"
                            :query="warehouse.query"
                            :page="warehouse.page"
                            :searchColumns="warehouse.searchColumns"
                            :columnList="warehouse.columnList"
                            :isMultiple="true"
                            :currentValue="row.storageName"
                            @setSearchModal="(name, val) => setWarehouse(name, val, row)"
                          ></SearchModal>
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="storageAddress"
                        :title="$t('warehouseContract.form.storageAddress')"
                        :edit-render="{
                          name: 'ElInput',
                          defaultValue: '',
                          props: { clearable: true },
                          maxlength: '32',
                        }"
                        :placeholder="$t('warehouseContract.form.storageAddressPlaceholder')"
                      ></vxe-table-column>
                    </vxe-grid>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  <div class="collapse-title-pre"
                    ><span></span>{{ this.$t('warehouseContract.form.systemInfo') }}</div
                  >
                </template>
                <div class="collapse-content">
                  <el-form :model="formData" :rules="rules" label-width="90px">
                    <el-row>
                      <el-col :span="6">
                        <el-form-item
                          prop="contractCompanyName"
                          :label="this.$t('warehouseContract.form.contractCompanyNo')"
                        >
                          <el-input
                            v-model="formData.contractCompanyName"
                            :disabled="true"
                            :placeholder="
                              this.$t('warehouseContract.form.contractCompanyNoPlaceholder')
                            "
                            clearable
                            maxlength="32"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          prop="contractCreatePersonName"
                          :label="this.$t('warehouseContract.form.contractCreatePersonNo')"
                        >
                          <el-input
                            v-model="formData.contractCreatePersonName"
                            :disabled="true"
                            :placeholder="
                              this.$t('warehouseContract.form.contractCreatePersonNoPlaceholder')
                            "
                            clearable
                            maxlength="32"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          prop="contractCreateDate"
                          :label="this.$t('warehouseContract.form.contractCreateDate')"
                        >
                          <el-date-picker
                            style="width: 100%"
                            v-model="formData.contractCreateDate"
                            :disabled="true"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            :placeholder="
                              this.$t('warehouseContract.form.contractCreateDatePlaceholder')
                            "
                            clearable
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item
                          prop="contractMark"
                          :label="this.$t('warehouseContract.form.contractMark')"
                        >
                          <el-input
                            v-model="formData.contractMark"
                            :disabled="canNotEdit"
                            :placeholder="this.$t('warehouseContract.form.contractMarkPlaceholder')"
                            clearable
                            maxlength="256"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </el-tab-pane>
        <!-- 商品信息 -->
        <el-tab-pane :label="this.$t('warehouseContract.form.goodsInfo')">
          <div class="gird">
            <vxe-toolbar size="mini">
              <template v-slot:buttons>
                <vxe-button
                  size="medium"
                  type="primary"
                  class="vxe-btn-primary"
                  icon="el-icon-plus"
                  @click="addGoodsRow"
                >
                  {{ $t('credit.btnList.add') }}
                </vxe-button>
                <vxe-button
                  size="medium"
                  type="primary"
                  class="vxe-btn-delete"
                  icon="el-icon-delete"
                  @click="removeSelected('xGridGood')"
                >
                  {{ $t('credit.btnList.del') }}
                </vxe-button>
              </template>
            </vxe-toolbar>
            <vxe-grid
              border
              show-overflow
              resizable
              ref="xGridGood"
              class="vxe-table-element"
              size="mini"
              align="left"
              :auto-resize="true"
              :data="goodsData"
              :edit-rules="productEditRules"
              @cell-click="goodsRowClick"
              :edit-config="{ trigger: 'click', mode: 'row' }"
            >
              <vxe-table-column type="checkbox" width="60"></vxe-table-column>
              <vxe-table-column
                type="index"
                width="60"
                :title="$t('table.index')"
              ></vxe-table-column>
              <vxe-table-column
                field="storageNo"
                :title="$t('warehouseContract.form.storageNo')"
                :edit-render="{ name: 'searchModal' }"
              >
                <template v-slot:edit="{ row }">
                  <SearchModal
                    v-if="canNotEdit == false"
                    ref="searchModal"
                    propName="storageCode"
                    propCode="storageCode"
                    model="storageName"
                    className="customer-search"
                    :placeholder="$t('warehouseContract.form.storagePlaceholder')"
                    :API="warehouse.API"
                    :query="warehouse.query"
                    :page="warehouse.page"
                    :searchColumns="warehouse.searchColumns"
                    :columnList="warehouse.columnList"
                    :isMultiple="true"
                    :currentValue="row.storageNo"
                    @setSearchModal="setGoodWarehouse"
                  ></SearchModal>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="storageName"
                :title="$t('warehouseContract.form.storageName')"
                :edit-render="{ name: 'searchModal' }"
              >
                <template v-slot:edit="{ row }">
                  <SearchModal
                    v-if="canNotEdit == false"
                    ref="searchModal"
                    propName="storageName"
                    propCode="storageCode"
                    model="storageName"
                    className="customer-search"
                    :placeholder="$t('warehouseContract.form.storagePlaceholder')"
                    :API="warehouse.API"
                    :query="warehouse.query"
                    :page="warehouse.page"
                    :searchColumns="warehouse.searchColumns"
                    :columnList="warehouse.columnList"
                    :isMultiple="true"
                    :currentValue="row.storageName"
                    @setSearchModal="setGoodWarehouse"
                  ></SearchModal>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="productName"
                :title="$t('warehouseContract.form.goodName')"
                :edit-render="{ name: 'searchModal' }"
              >
                <template v-slot:edit="{ row }">
                  <SearchModal
                    v-if="canNotEdit == false"
                    ref="searchModal"
                    :propName="goods.propName"
                    :propCode="goods.propCode"
                    model="productName"
                    className="customer-search"
                    :placeholder="$t('warehouseContract.form.goodNamePlaceholder')"
                    :API="goods.API"
                    :query="goods.query"
                    :page="goods.page"
                    :searchColumns="goods.searchColumns"
                    :columnList="goods.columnList"
                    :isMultiple="true"
                    :currentValue="row.productName"
                    @setSearchModal="setProduct"
                  ></SearchModal>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="storageExpense"
                :title="$t('warehouseContract.form.storageExpense')"
                :edit-render="{ name: 'input' }"
                :placeholder="$t('warehouseContract.form.storageExpensePlaceholder')"
              >
                <template v-slot:edit="{ row }">
                  <input-number-ad max="99999999999.999999" v-model="row.storageExpense">
                  </input-number-ad>
                </template>
                <template v-slot="{ row }">
                  {{ $baseRequest.formatTableColumn(row.storageExpense) }}
                </template>
              </vxe-table-column>
            </vxe-grid>
          </div>
        </el-tab-pane>
        <!-- 附件信息 -->
        <el-tab-pane :label="this.$t('warehouseContract.form.attachmentInfo')">
          <upload
            ref="upload"
            defaultPath="scm/warehouseContract"
            :tableData="attachmentList"
            @upload="uploadList"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="isEdit == false || contractStatus == 'ZT06'"
        type="primary"
        @click="save"
        v-hasPermi="['2021050814403278053']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        type="primary"
        @click="commit"
        v-hasPermi="['2021050814402234922']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.commit') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import API from '@/api/logisticsCenter/warehouseContract.js';
  import DataBaseAPI from '@/api/dataBase';
  import upload from '@/components/upload';
  import formRules from './rules/rules';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import searchTable from '@/components/form-item/search-table';

  export default {
    components: {
      SearchModal,
      upload,
      inputNumberAd,
      searchTable,
    },
    name: 'wareHouseContractBaseEdit',
    data() {
      let newDate = new Date();
      let canNotEdit = this.$route.query.canNotEdit == '0' ? true : false;
      return {
        contractStatus: '',
        contractType: '01',
        warehouseRowIndex: 0,
        goodsRowIndex: 0,
        inboundMethodList: [],
        contractNo: null,
        // isEdit:false,
        warehouseData: [],
        goodsData: [],
        tableToolbar: {
          id: 'toolbar',
          // refresh: true,
          // setting: {
          //   storage: true
          // }
        },
        canNotEdit: canNotEdit,
        isEdit: !canNotEdit,
        load: false,
        attachmentList: [], //附件列表
        activeNames: ['1', '2', '3', '4', '5', '6', '7'], //默认展开那些面板，
        formData: {
          contractCreateDate: newDate, //申请时间
          contractCreatePersonNo: '',
          contractCreatePersonName: '',
          contractCompanyName: '',
          contractCompanyNo: '',
          contractEnterpriseNo: '',
          contractEnterpriseName: '',
          inboundMethod: '',
          productCategory: '12',
          feature: '23',
          storageAddress: '中国',
        },
        storageNo: '',
        rules: formRules.formRules,
        productEditRules: formRules.productEditRules,
        warehouseEditRules: formRules.warehouseEditRules,
        numberObj: {
          max: 999999999999,
          precision: 6,
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),

      //合作伙伴
      partner() {
        return {
          API: DataBaseAPI.PARTNER_LIST_API,
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          query: {
            requestStatus: 'ZT03',
            partnerType: 'HZHB07',
            //adminFlag: this.userInfo.userInfo.adminFlag,
          },
          searchColumns: [
            {
              name: window.vm.$t('cooperation.label.partnerZhName'),
              prop: 'partnerZhName',
              type: 'input',
            },
          ],
          columnList: [
            { prop: 'partnerZhName', label: window.vm.$t('cooperation.label.partnerZhName') },
            { prop: 'partnerCode', label: window.vm.$t('cooperation.label.partnerCode') },
            { prop: 'identityNo', label: window.vm.$t('cooperation.label.identityNo') },
            { prop: 'creditCode', label: window.vm.$t('cooperation.label.creditCode') },
            { prop: 'requestByName', label: window.vm.$t('cooperation.label.requestByName') },
            { prop: 'requestTime', label: window.vm.$t('cooperation.label.requestTime') },
            //   { prop: "requestStatus", label: window.vm.$t('cooperation.label.requestStatus') },
          ],
        };
      },
      //仓库
      warehouse() {
        return {
          propName: 'storageName', // 输入框展示内容
          propCode: 'storageCode',
          query: {
            storageCode: '',
            storageName: '',
            //adminFlag: this.userInfo.userInfo.adminFlag,
            adminFlag: 1,
            storageCompanyCode: this.storageNo,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              prop: 'storageCode',
              name: window.vm.$t('warehouse.search.warehouseCode'),
              type: 'input',
              placeholder: window.vm.$t('warehouse.search.warehouseCodePlaceholder'),
            },
            {
              prop: 'storageName',
              name: window.vm.$t('warehouse.search.warehouseName'),
              type: 'input',
              placeholder: window.vm.$t('warehouse.search.warehouseNamePlaceholder'),
            },
          ],
          API: DataBaseAPI.STORAGE_LIST_API,
          columnList: [
            {
              prop: 'storageCode',
              label: window.vm.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: window.vm.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: window.vm.$t('warehouse.table.createWarehouseAddress'),
            },
            {
              prop: 'storageCompanyCode',
              label: window.vm.$t('warehouse.table.createWarehouseCompanyCode'),
            },
            {
              prop: 'storageCompanyName',
              label: window.vm.$t('warehouse.table.createWarehouseCompanyName'),
            },
            {
              prop: 'personName',
              label: window.vm.$t('warehouse.table.gmtCreateBy'),
            },
            {
              prop: 'storageCreateTime',
              label: window.vm.$t('warehouse.table.gmtCreate'),
            },
            // { prop: "currentStatus", label: window.vm.$t("warehouse.table.status") }
          ],
        };
      },
      //商品子类
      goods() {
        return {
          width: '800',
          query: {
            detailProductDisplayName: null,
            productDetailCode: null,
          },
          API: DataBaseAPI.LIST_DETAIL_PRODUCT,
          extraData: {
            //已生效
            detailProductStatus: 'ZT03',
            adminFlag: this.userInfo.adminFlag,
            selectCompanyCode: this.userInfo.companyCode,
          },
          propCode: 'productDetailCode',
          propName: 'detailProductDisplayName',
          searchColumns: [
            {
              prop: 'productDetailCode',
              name: window.vm.$t('goods.search.productDetailCode'),
              type: 'input',
              placeholder: '请输入',
            },
            {
              name: window.vm.$t('goods.search.detailProductDisplayName'),
              prop: 'detailProductDisplayName',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'productDetailCode',
              label: window.vm.$t('goods.table.productDetailCode'),
              width: 200,
            },
            {
              prop: 'detailProductDisplayName',
              label: window.vm.$t('goods.table.detailProductDisplayName'),
              width: 200,
            },
            {
              prop: 'detailProductModel',
              label: window.vm.$t('goods.table.detailProductModel'),
            },
          ],
        };
      },
    },
    mounted() {
      this.userInfo.userInfo;
      this.version = this.$route.query.version;
      //控制页面是否可修改
      if (this.$route.query && this.$route.query.canEdit && this.$route.query.canEdit == '0') {
        this.canNotEdit = true;
      } else {
        this.canNotEdit = false;
      }
      this.contractNo = this.$route.query.contractNo || null;
      if (this.contractNo) {
        this.isEdit = true;
        this.getData();
      } else {
        this.isEdit = false;
        this.formData.contractCompanyName = this.userInfo.userInfo.companyName;
        this.formData.contractCompanyNo = this.userInfo.userInfo.companyCode;
        this.formData.contractCreatePersonName = this.userInfo.userInfo.userName;
        this.formData.contractCreatePersonNo = this.userInfo.userInfo.userCode;
        this.formData.contractUpdatePersonName = this.userInfo.userInfo.userName;
      }
      this.getDic();
    },
    methods: {
      changeInboundMethod() {
        if (this.formData.inboundMethod != 'RK01') {
          this.$refs.formData.clearValidate('stationName');
        }
      },
      //选中商品列表中的某一条
      goodsRowClick(value) {
        this.goodsRowIndex = value.$rowIndex;
      },
      //选中仓库中的某一条
      warehouseRowClick(value) {
        this.warehouseRowIndex = value.$rowIndex;
      },
      //新增仓库
      insertRow() {
        if (!this.formData.contractEnterpriseNo || !this.formData.contractEnterpriseName) {
          this.$message({
            showClose: true,
            message: '请选择签约单位',
            type: 'info',
          });
          return;
        }
        this.warehouseData.push({ storageNo: '', storageName: '', storageAddress: '' });
      },
      //选择仓库
      setWarehouse(name, val) {
        console.log(name);
        if (val.length > 0) {
          this.warehouseData[this.warehouseRowIndex].storageNo = val[0].storageCode;
          this.warehouseData[this.warehouseRowIndex].storageName = val[0].storageName;
          this.warehouseData[this.warehouseRowIndex].storageAddress = val[0].storageAddress;
          this.$refs.xGrid.updateData();
        }
      },
      //选择仓库-商品信息
      setGoodWarehouse(name, val) {
        if (val.length > 0) {
          this.goodsData[this.goodsRowIndex].storageNo = val[0].storageCode;
          this.goodsData[this.goodsRowIndex].storageName = val[0].storageName;
          this.$refs.xGridGood.updateData();
        }
      },
      //选择商品信息
      setProduct(name, val) {
        if (val.length > 0) {
          this.goodsData[this.goodsRowIndex].productNo = val[0].productDetailCode;
          this.goodsData[this.goodsRowIndex].productName = val[0].detailProductDisplayName;
        }
      },
      //新增商品
      addGoodsRow() {
        if (!this.formData.contractEnterpriseNo || !this.formData.contractEnterpriseName) {
          this.$message({
            showClose: true,
            message: '请选择签约单位',
            type: 'info',
          });
          return;
        }
        this.goodsData.push({});
      },
      //获取详情
      getData() {
        let params = {
          contractType: this.contractType,
          contractNo: this.contractNo,
        };
        this.$axios.get(API.DETAIL_CONTRACT__API, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.formData = res.data.data;
            this.storageNo = this.formData.contractEnterpriseNo;
            this.attachmentList = res.data.data.distributionAttachments;
            this.warehouseData = res.data.data.distributionContractStorages;
            this.goodsData = res.data.data.distributionContractProducts;
            this.contractStatus = this.formData.contractStatus;
            this.version = this.formData.version;
            this.$nextTick(() => {
              this.$refs.formData.clearValidate();
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //选择签约单位
      setWarehouseIn(value) {
        if (value.length > 0) {
          if (this.storageNo != value[0].partnerCode) {
            this.formData.contractEnterpriseNo = value[0].partnerCode;
            this.formData.contractEnterpriseName = value[0].partnerZhName;
            this.storageNo = value[0].partnerCode;
            this.warehouseData = [];
            this.goodsData = [];
          }
          // this.formData.registeredAssets = value[0].storageAddress
          // this.formData.contactPersonNo=value[0].personName
          // this.formData.contactPhone=value[0].contactTelephone
        }
      },
      //获取字典值
      getDic() {
        //入库方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'warehousing_mode',
            tenantCode: this.userInfo.userInfo.tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.inboundMethodList = res.data.data;
            }
          });
      },
      //删除仓库/商品
      removeSelected(tableName) {
        let data = this.$refs[tableName].getSelectRecords();
        if (data && data.length > 0) {
          let list = [];
          data.map((item) => {
            if (item.id) {
              list.push(item);
            }
          });
          this.$confirmAction()
            .then(() => {
              if (list.length > 0) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                //如果有错误返回，提示信息
                this.$alert('我是错误信息');
              } else {
                this.$refs[tableName].removeSelecteds();
                if (tableName == 'xGrid') {
                  this.warehouseData = this.$refs.xGrid.getTableData().fullData;
                } else {
                  this.goodsData = this.$refs.xGridGood.getTableData().fullData;
                }
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: '您还没选择要修改的数据',
            type: 'error',
          });
        }
      },
      //保存/提交
      save() {
        this.saveData('ZT06');
      },
      //提交
      commit() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.$refs.xGrid.validate((valid) => {
              if (valid) {
                this.$refs.xGridGood.validate((valid) => {
                  if (valid) {
                    this.saveData('ZT02');
                  } else {
                    this.$message({
                      showClose: true,
                      message: this.$t('warehouseContract.form.goodsInfoMessage'),
                      type: 'error',
                    });
                  }
                });
              }
            });
          }
        });
      },
      //调用保存方法
      saveData(status) {
        this.load = true;
        let data = this.formData;
        if (this.$route.query && this.$route.query.version) {
          data.version = this.version;
        }
        if (this.contractNo) {
          data.contractNo = this.contractNo;
        }
        data.contractStatus = status;
        data.contractType = this.contractType;
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        data.admin = this.userInfo.userInfo.adminFlag;
        data.contractUpdatePersonName = this.userInfo.userInfo.userName;
        //仓库列表
        let distributionContractStorages = [];
        if (this.warehouseData && this.warehouseData.length > 0) {
          this.warehouseData.map((item) => {
            if (item.storageNo || item.storageName || item.storageAddress) {
              let id = item._XID;
              item.sortNo = id.substring(4, id.length);
              distributionContractStorages.push(item);
            }
          });
        }
        data.distributionContractStorages = JSON.stringify(distributionContractStorages);
        //商品列表
        let distributionContractProducts = [];
        if (this.goodsData && this.goodsData.length > 0) {
          this.goodsData.map((item) => {
            if (
              item.storageNo ||
              item.storageName ||
              item.productGood ||
              item.productNo ||
              item.storageAddress
            ) {
              let id = item._XID;
              item.sortNo = id.substring(4, id.length);
              distributionContractProducts.push(item);
            }
          });
        }
        data.distributionContractProducts = JSON.stringify(distributionContractProducts);
        //附件列表
        //let attachmentList = this.$refs.upload.getVal()
        //console.log(attachmentList)
        let list = [];
        if (this.attachmentList && this.attachmentList.length > 0) {
          this.attachmentList.map((item) => {
            let id = item._XID;
            let obj = {
              attachmentName: item.attachmentName,
              attachmentPath: item.attachmentPath,
              sortNo: id.substring(4, id.length),
              gmtCreate: item.gmtCreate,
              createBy: item.createBy,
            };
            if (item.attachmentId) {
              obj.attachmentId = item.attachmentId;
            }
            if (item.tenantCode) {
              obj.tenantCode = item.tenantCode;
            }
            if (item.companyCode) {
              obj.companyCode = item.companyCode;
            }
            if (item.departmentCode) {
              obj.departmentCode = item.departmentCode;
            }
            if (item.companyName) {
              obj.companyName = item.companyName;
            }
            if (item.departmentName) {
              obj.departmentName = item.departmentName;
            }
            list.push(obj);
          });
        }
        data.distributionAttachments = JSON.stringify(list);
        this.$axios.post(API.ADD_CONTRACT_API, data).then((res) => {
          if (0 == res.data.code) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            if (status == 'ZT06') {
              if (this.$route.name == 'wareHouseContractAdd') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getData();
              }
            } else {
              this.toPath();
            }
          } else {
            this.load = false;
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/logistics/wareHouseContractAdd',
            name: 'wareHouseContractAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/logistics/wareHouseContractDetail',
            name: 'wareHouseContractDetail',
            meta: {
              keepAlive: false,
            },
            query: { contractNo: value.contractNo, canEdit: '0' },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      toPath() {
        let path = {
          fromPath: {
            path: '/logistics/wareHouseContractAdd',
            name: 'wareHouseContractAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/logistics/wareHouseContractList',
            name: 'wareHouseContractList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //更新附件列表
      uploadList(value) {
        this.attachmentList = value;
      },
    },
    watch: {},
  };
</script>
